import { call, put } from "redux-saga/effects";
import { UserProfileResponse } from "reduxStore/dataTypes";
import { fetchProfile } from "services/apiService";
import {
  profileFailure,
  profileSuccess,
  profileRequest,
} from "../reducers/userReducer";

function* userSaga(): Generator<any, void, UserProfileResponse | any> {
  try {
    yield put(profileRequest());
    let response = yield call(fetchProfile);
    yield put(profileSuccess(response.data));
  } catch (error: any) {
    if (error && error.response) {
      yield put(profileFailure(error.response));
    } else {
      yield put(profileFailure(error.message));
    }
  }
}

export default userSaga;
